import { FaCode } from "react-icons/fa";
import { SnippetsHomeViewMain } from "../Components/SnippetsHomeViewMain";
import { SnippetRepositoryViewMain } from "../Components/SnippetRepositoryViewMain";

const BASE = {
    views: "PRIVATE",
    roles: null,
    permissions: null,
    icon: <FaCode />,
    displayInHeader: false,
    displayInFooter: false,
    displayInSidebar: false,
    isBlockedWhenLogged: false,
};

export const SnippetsModule = () => [
    { ...BASE, path: "/snippets", component: <SnippetsHomeViewMain />, label: "Snippets" },
    { ...BASE, path: "/snippets/:repositoryId", component: <SnippetRepositoryViewMain />, label: "Repositorio de snippets" },
];
